import React, { useState } from 'react';
import { Button } from 'components/base';
import { RoundFillableSelect } from 'styled';
import {
  Container,
  ChoiceContainer,
  LabelContainer,
  Label,
  ChoicesContainer,
  Button as StyledButton,
  Connector,
} from './style';
import { SurveyQuestion, SurveyChoice, SurveyResponse } from 'types';
import Language from 'constants/Language';

export interface Props {
  question: SurveyQuestion;
  surveyResponse: SurveyResponse;
  setSurveyResponse(response: SurveyResponse): void;
}

const TrackSelect = (props: Props) => {
  const { question, surveyResponse, setSurveyResponse } = props;

  const [currentHoveredChoice, setCurrentHoveredChoice] = useState<
    SurveyChoice['id'] | null
  >(null);

  const handleClearHover = () => setCurrentHoveredChoice(null);

  const currentHoveredChoiceIndex = question.choices.findIndex(
    (choice) =>
      currentHoveredChoice !== null && choice.id === currentHoveredChoice
  );

  const currentSelectedChoiceIndex = question.choices.findIndex(
    (choice) =>
      surveyResponse[question.id] !== null &&
      choice.id === surveyResponse[question.id]
  );

  if (question.choices.length < 2) return null;

  return (
    <Container>
      <LabelContainer mb={[1, 1, 1, 1.5]}>
        <Label>{question.choices[0].text}</Label>
        <Label>{question.choices[question.choices.length - 1].text}</Label>
      </LabelContainer>
      <ChoicesContainer onMouseLeave={handleClearHover}>
        {question.choices.map((choice, index) => {
          const choiceSelectHasConnectorOnRightSide =
            index < question.choices.length - 1;

          const handleButtonClick = () =>
            setSurveyResponse({
              ...surveyResponse,
              [question.id]: choice.id,
            });

          const handleSetHover = () => setCurrentHoveredChoice(choice.id);

          return (
            <ChoiceContainer
              key={choice.id}
              totalNumberOfChoices={question.choices.length}
              choiceSelectHasConnectorOnRightSide={
                choiceSelectHasConnectorOnRightSide
              }
            >
              <StyledButton
                as={Button}
                ariaLabel={Language.t('ArticleResearch.selectOptionAriaLabel', {
                  option: choice.text,
                })}
                onMouseEnter={handleSetHover}
                onClick={handleButtonClick}
              >
                <RoundFillableSelect
                  innerCircleColor={
                    currentSelectedChoiceIndex >= index ||
                    currentHoveredChoiceIndex >= index
                      ? 'orange-light'
                      : 'white'
                  }
                  outerCircleColor={
                    currentSelectedChoiceIndex >= index ||
                    currentHoveredChoiceIndex >= index
                      ? 'orange-light'
                      : 'black'
                  }
                />
              </StyledButton>
              {choiceSelectHasConnectorOnRightSide && (
                <Connector
                  color={
                    currentSelectedChoiceIndex > index ||
                    currentHoveredChoiceIndex > index
                      ? 'orange-light'
                      : 'black'
                  }
                />
              )}
            </ChoiceContainer>
          );
        })}
      </ChoicesContainer>
    </Container>
  );
};

export default TrackSelect;
